import { Text } from "@mantine/core"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { ActionIcon } from "@tfg/ui"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { DateCell } from "~/components/cells/DateCell"

import { useDeleteRefreshTokenMutation } from "./hook"

export type Props = {
  id: number
  onClick: (id: number) => void
}

const columnHelper = createColumnHelper<AdminResponses.RefreshTokenLogs>()
export const useRefreshTokenColumns = () => {
  const { mutate: deleteRefreshToken } = useDeleteRefreshTokenMutation()

  return useMemo<ColumnDef<AdminResponses.RefreshTokenLogs, any>[]>(
    () => [
      columnHelper.accessor("id", {
        header: "ID",
        enableSorting: false,
        cell: (info) => <Text>{info.getValue()}</Text>,
      }),
      columnHelper.accessor("user.email", {
        header: "User Email",
        enableSorting: false,
        cell: (info) => <Text>{info.getValue()}</Text>,
      }),
      columnHelper.accessor("adminEmail", {
        header: "Admin Email",
        enableSorting: false,
        cell: (info) => <Text>{info.getValue()}</Text>,
      }),
      columnHelper.accessor("isAdmin", {
        header: "isAdmin",
        enableSorting: false,
        cell: (info) => {
          const isAdmin = info.getValue()
          if (isAdmin) return <Text>TRUE</Text>
          return <Text>FALSE</Text>
        },
      }),
      columnHelper.accessor("createdAt", {
        header: "createdAt",
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        sortingFn: "datetime",
      }),
      columnHelper.accessor("updatedAt", {
        header: "updatedAt",
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        sortingFn: "datetime",
      }),
      columnHelper.accessor("deletedAt", {
        header: "Deleted",
        enableSorting: false,
        cell: ({ row, getValue }) => {
          const deletedAt = getValue()
          if (deletedAt) return <Text>TRUE</Text>
          return (
            <ActionIcon
              type="delete"
              onClick={() => deleteRefreshToken(row.original.id)}
            />
          )
        },
      }),
    ],
    [deleteRefreshToken]
  )
}
